<template>
  <div class="section norms">
    <div class="section__header">Normy</div>
    <div class="norms__box" @click="emit('toggle')">
      <div class="label">Pokazuj normy</div>
      <BaseSwitch class="norms__switch" :value="active" />
    </div>
    <div class="info">
      <BaseIcon name="info" />
      Włączając tę funkcję zyskasz możliwość śledzenia realizacji najnowszych Norm żywienia 2024
      oraz zmodyfikujesz podaż poszczególnych składników dla danego przypadku.
    </div>
    <PatientParameters v-bind="patient" v-on="patientListeners" />
    <NutrientNormGroup
      v-for="group in normsAssumptions"
      :key="group.name"
      :calculated-norm="calculatedNorm"
      :can-edit="canEdit"
      :group="group"
      :inputed-norm="inputedNorm"
      :precision="getPrecision(group.name)"
      :step="getStep(group.name)"
      @update="(key, value) => emit('update', key, value)"
      @upgrade="emit('upgrade')"
    />
  </div>
</template>

<script lang="ts" setup>
  import BaseIcon from '@/components/BaseIcon.vue'
  import BaseSwitch from '@/components/BaseSwitch.vue'
  import { normsAssumptions } from '@/utils/norms'

  import type { Nutrients } from '@/utils/nutrients'

  import NutrientNormGroup from '../NutrientNormGroup/NutrientNormGroup.vue'
  import PatientParameters from '../PatientParameters/PatientParameters.vue'

  defineProps<{
    active: boolean
    calculatedNorm: (key: Nutrients) => number | 'b.d.'
    canEdit: boolean
    getPrecision: (group: string) => number
    getStep: (group: string) => number
    inputedNorm: (key: Nutrients) => number
    patient: InstanceType<typeof PatientParameters>['$props']
    patientListeners: Record<string, (...args: any[]) => any>
  }>()
  const emit = defineEmits<{
    toggle: []
    update: [key: Nutrients, value: number]
    upgrade: []
  }>()
</script>
